<template>
  <v-dialog v-model="selectedLinkData.modal" width="99%" max-width="600" persistent>
    <v-card v-if="selectedLinkData.data">
      <v-col class="pa-4 pb-1" align="center" style="font-size: 18px; font-weight: bold">
        Modification de ma redirection
        <v-btn
          @click="selectedLinkData.modal = false"
          style="position: absolute; right: 5px; top: 5px"
          icon="mdi-close"
          color="red"
          density="compact"
        ></v-btn>
      </v-col>
      <v-col>
        <v-row justify="center" align="center">
          <v-col cols="">
            <v-text-field
              label="Ancre"
              v-model="selectedLinkData.data.key"
              hide-details
            ></v-text-field>
          </v-col>
          <v-col cols="auto">
            <v-btn
              v-if="userInformation.admin_lvl == 2"
              color="red"
              style="cursor: pointer"
              class="button_armo"
              icon
              density="compact"
              @click="removeLink()"
            >
              <v-icon size="17"> mdi-trash-can </v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
      <v-col>
        <div
          v-if="
            internLinkData[selectedSiteToShow.uuid] &&
            linkData[selectedLinkType].value == 0 &&
            internLinkData[selectedSiteToShow.uuid].urlListeByType &&
            Object.keys(internLinkData[selectedSiteToShow.uuid].urlListeByType).length > 0
          "
        >
          <v-autocomplete
            hide-details
            label="Filtre d'URL par catégorie"
            clearable
            no-data-text="Aucune catégorie trouvée"
            :items="Object.keys(internLinkData[selectedSiteToShow.uuid].urlListeByType)"
            v-model="selectedKeysToShow"
          >
          </v-autocomplete>
          <v-divider></v-divider>
        </div>
        <div v-if="linkData[selectedLinkType].value == 0">
          <v-autocomplete
            menu-icon=""
            clearable
            no-data-text="Aucune page trouvée"
            label="URL de redirection"
            class="pa-0"
            v-model="selectedLinkData.data.url"
            style="border-radius: 0px !important; width: 100%; overflow: auto"
            :items="
              internLinkData[selectedSiteToShow.uuid].finalUrlData
                .filter(
                  (val2) =>
                    !selectedSiteToShow.link_connection
                      .map((val) => val.url)
                      .includes(val2.value)
                )
                .filter((val) => haveCommonElement(val.keys, selectedKeysToShow))
            "
            hide-details
          >
            <!-- <template v-slot:chip="{ props, item }">
              <div v-bind="props" style="z-index: 1;background-color:#DDDDDD;width:100%">
                {{ item.value }}
              </div>
            </template>
            <template v-slot:item="{ props, item }">
              <v-list-item v-bind="props">
                {{ item.value.url }}
              </v-list-item>
            </template> -->
          </v-autocomplete>
        </div>
        <v-textarea
          v-else
          label="URL de redirection"
          v-model="selectedLinkData.data.url"
          hide-details
          placeholder="https://mon-url..."
          menu-icon=""
          auto-grow
          rows="1"
          style="border-radius: 0px !important; overflow: auto; width: 100%"
        >
        </v-textarea>
      </v-col>
      <v-col>
        <v-select
          label="REL"
          :items="relListe"
          v-model="selectedLinkData.data.rel"
          item-value="value"
          item-title="label"
          hide-details
          style="border-radius: 0px !important; width: 100%; overflow: auto"
        >
        </v-select>
      </v-col>
      <v-col>
        <v-select
          label="Nombre de redirection MAX dans un article"
          v-model="selectedLinkData.data.max"
          alig="center"
          :items="[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]"
          hide-details
        >
        </v-select>
      </v-col>
      <v-col align="center" class="pt-0">
        <v-divider class="mb-4"></v-divider>
        <v-btn class="button" @click="updateDataLink"> Enregistrer </v-btn>
      </v-col>
    </v-card>
  </v-dialog>
  <v-dialog v-model="closeData.model" width="auto">
    <v-card>
      <v-col align="center">
        <div class="my-2" style="font-weight: bold">
          {{ closeData.label }}
        </div>
        <v-row>
          <v-col>
            <v-btn
              class="button_armo"
              style="background-color: red; color: white"
              @click="closeData.model = false"
            >
              Non
            </v-btn>
          </v-col>
          <v-col>
            <v-btn
              class="button_armo"
              style="background-color: green; color: white"
              @click="closeData.callback"
            >
              OUi
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-card>
  </v-dialog>
  <v-col v-if="localGroupInformation && localGroupInformation.web_site_data">
    <v-btn
      icon="mdi-close"
      style="position: fixed; right: 15px; top: 15px; z-index: 2"
      density="compact"
      color="red"
      @click="closeModalVerif"
    ></v-btn>
    <v-col
      style="color: white; font-size: 25px; font-weight: bold"
      align="center"
      class="mb-2 pt-1"
      >Gestion de votre Jauris</v-col
    >
    <v-row style="background-color: var(--C4)" v-if="localGroupInformation">
      <v-col
        v-if="
          platformToShow.length > 1 ||
          localGroupInformation.web_site_data[selectedPlatformToShow].length > 1
        "
      >
        <v-row>
          <v-col v-if="platformToShow.length > 1">
            <v-card
              style="border-radius: 30px; border: solid 1px lightgrey"
              variant="flat"
            >
              <v-select
                style="min-width: 160px"
                density="compact"
                label="Platforme a afficher"
                bg-color="white"
                v-model="selectedPlatformToShow"
                :items="platformToShow"
                hide-details
              >
              </v-select>
            </v-card>
          </v-col>
          <v-col
            cols=""
            class="py-2 pr-0"
            v-if="
              selectedPlatformToShow &&
              localGroupInformation.web_site_data[selectedPlatformToShow].length > 1
            "
          >
            <v-card
              style="border-radius: 30px; border: solid 1px lightgrey"
              variant="flat"
            >
              <v-select
                density="compact"
                hide-details
                bg-color="white"
                item-title="label"
                label="Site sélectionné"
                return-object
                v-model="selectedSiteToShow"
                :items="localGroupInformation.web_site_data[selectedPlatformToShow]"
              >
              </v-select>
            </v-card>
          </v-col>
        </v-row>
      </v-col>

      <!-- <v-col class="mb-2 cms-panel" style="overflow: auto" cols="12">
        <v-expansion-panels v-model="panelOpened">
          <v-expansion-panel          >
            <v-expansion-panel-title class="bg" style="color: white">
              <template v-slot:default="{}">
                <v-row no-gutters>
                  <v-col class="d-flex justify-start" cols="4">
                    {{ selectedSiteToShow.label }}
                  </v-col>
                </v-row>
              </template>
            </v-expansion-panel-title>
            <v-expansion-panel-text> -->
      <v-col cols="12" class="pa-0">
        <v-card style="border-radius: 0px" align="left" variant="flat" class="bg">
          <div style="position: absolute; right: 10px; top: 10px">
            <v-icon
              style="cursor: pointer"
              color="red"
              @click="removeBusiness(selectedPlatformToShow, i)"
              >mdi-minus-circle</v-icon
            >
          </div>
          <v-col>
            <v-row>
              <v-col v-for="subKey in keyToShow" :key="subKey" cols="12" class="pa-2">
                <v-card v-if="subKey.key == 'words_liste'" class="pa-2">
                  <v-col cols="12" class="pl-0" style="font-weight: bold">
                    Mots clés principaux<span style="color: grey; font-size: 12px">
                      (maximum de 10 mots clés)</span
                    >
                    <v-btn
                      v-if="userInformation.admin_lvl == 2"
                      :disabled="hideUpdateBtn"
                      class="button ml-4"
                      density="compact"
                      @click="updateProposition"
                      >Mettre à jour les propositions d'article</v-btn
                    >
                  </v-col>
                  <v-divider class="mb-3"></v-divider>
                  <v-col v-if="selectedSiteToShow[subKey.key]" class="px-2 pb-2">
                    <v-row class="">
                      <v-col
                        v-for="(tags, idx) in selectedSiteToShow[subKey.key].split(',')"
                        :key="idx"
                        class="py-1 px-0"
                        cols="auto"
                      >
                        <v-chip
                          class="mx-1"
                          v-if="tags.replaceAll(' ', '').length != 0"
                          style="cursor: pointer; border-radius: 0px"
                          @click="removeTag(idx)"
                        >
                          {{ tags }} <v-icon color="red">mdi-close-thick</v-icon>
                        </v-chip>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col >
                    <v-row align="center">
                      <v-col cols="" class="px-0">
                        <v-card :class="subKey.class" variant="flat">
                          <v-text-field
                            label="Ajouter des mots clés principaux"
                            v-model="newTag[selectedSiteToShow.uuid]"
                            style=""
                            hide-details
                            class=""
                          ></v-text-field>
                        </v-card>
                      </v-col>
                      <v-col cols="auto">
                        <v-btn
                          height="55px"
                          variant="flat"
                          class="button"
                          style="font-weight: bold"
                          :disabled="
                            selectedSiteToShow[subKey.key]
                              .split(',')
                              .filter((val) => val.length > 0).length > 9
                          "
                          @click="addTag"
                        >
                          Ajouter
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-card>
                <v-card
                  v-else-if="subKey.key == 'link_connection'"
                  variant="flat"
                  style="border: solid 1px lightgray; border-radius: 5px"
                  class="pa-2"
                >
                  <v-col cols="12" style="font-weight: bold" class="pl-0">
                    Gestion des liens
                  </v-col>
                  <div v-if="isLinkLoading == false">
                    <v-btn
                      v-if="userInformation.admin_lvl == 2"
                      class="button_armo ma-1"
                      variant="flat"
                      color="red"
                      density="compact"
                      @click="selectedSiteToShow.link_connection = []"
                    >
                      Réinitialiser mes Ancres
                      <v-icon class="ml-2" size="18">mdi-delete</v-icon>
                    </v-btn>
                    <v-btn
                      variant="tonal"
                      class="button pt-0 ma-1"
                      v-if="userInformation.admin_lvl == 2"
                      density="compact"
                      @click="filleUrl"
                    >
                      Remplir mes ancres <v-icon class="ml-2">mdi-filter-variant</v-icon>
                    </v-btn>
                    <v-btn
                      variant="tonal"
                      class="button ma-1"
                      v-if="userInformation.admin_lvl == 2"
                      density="compact"
                      @click="updateUrlListe"
                    >
                      Charger les URLs de mon site
                      <v-icon class="ml-2">mdi-refresh</v-icon>
                    </v-btn>
                    <v-divider class="my-2"></v-divider>
                    <div>
                      <v-col>
                        <v-item-group mandatory v-model="selectedLinkType">
                          <v-row>
                            <v-col
                              v-for="linktype in linkData"
                              :key="linktype.value"
                              :cols="linktype.cols"
                              class="px-0"
                              @click="selectedLinkType = linktype.value"
                            >
                              <v-item v-slot="{ isSelected, toggle }">
                                <v-btn
                                  variant="flat"
                                  class="d-flex align-center"
                                  :style="
                                    isSelected
                                      ? 'background:var(--BG);color:white;'
                                      : 'background-color:#ECEFF1'
                                  "
                                  style="
                                    width: 100%;
                                    text-transform: none !important;
                                    border-radius: 0%;
                                  "
                                  @click="toggle"
                                >
                                  <div v-if="linktype.icon">
                                    <BasicHoverInformation
                                      position="left"
                                      :information="linktype.selectedSiteToShow"
                                    >
                                      <template v-slot:default>
                                        <v-icon
                                          :color="linktype.color"
                                          :size="linktype.size"
                                        >
                                          {{ linktype.icon }}
                                        </v-icon>
                                      </template>
                                    </BasicHoverInformation>
                                  </div>
                                  <div v-else>
                                    {{ linktype.label }}
                                  </div>
                                </v-btn>
                              </v-item>
                            </v-col>
                          </v-row>
                        </v-item-group>
                      </v-col>
                      <v-col
                        cols="12"
                        align="right"
                        class="pb-0 px-0"
                        v-if="userInformation.admin_lvl >= 1"
                      >
                        <v-btn @click="addLink" variant="flat" class="button">
                          <div style="font-size: 25px" class="">+</div>
                          Ajouter un lien
                        </v-btn>
                      </v-col>
                      <v-col class="pa-0">
                        <!-- <v-checkbox
                                                                v-if="selectedSiteToShow && linkData[selectedLinkType] && linkData[selectedLinkType].keyToShow"
                                                                density="compact" class="pb-2"
                                                                style="font-weight: bold;"
                                                                :label="'Activer la correspondance automatique de lien ' + linkData[selectedLinkType].keyToShow"
                                                                hide-details
                                                                v-model="selectedSiteToShow.use_link_connection[linkData[selectedLinkType].key]"></v-checkbox> -->
                        <div
                          class="px-1"
                          style="font-size: 12px; color: grey"
                          v-if="internLinkData && internLinkData[selectedSiteToShow.uuid]"
                        >
                          (
                          {{
                            internLinkData[selectedSiteToShow.uuid].finalUrlData.length
                          }}
                          URL trouvées / Liens paramétrés
                          {{
                            selectedSiteToShow.link_connection.filter(
                              (val) => val.value == selectedLinkType
                            ).length
                          }})
                        </div>
                      </v-col>
                      <v-col class="px-0" v-if="false && isAllSitePageLoading == false">
                        <v-card
                          style="border: solid 1px var(--C1); overflow-y: scroll"
                          :style="{ height: windowheight - 350 + 'px' }"
                        >
                          <table
                            style="
                              color: white;
                              text-overflow: clip;
                              width: 100%;
                              background: var(--BG);
                              overflow: scroll;
                            "
                            class="pa-1"
                          >
                            <thead>
                              <tr align="center">
                                <th style="width: auto" class="">
                                  <v-chip>
                                    Total :
                                    {{
                                      selectedSiteToShow.link_connection.filter(
                                        (val) => val.value == selectedLinkType
                                      ).length
                                    }}
                                  </v-chip>
                                </th>
                                <th
                                  style="width: 200px"
                                  class="pb-3"
                                  v-if="selectedLinkType != 2 && selectedLinkType != 3"
                                >
                                  <div align="center">Ancre de lien</div>
                                </th>
                                <th class="pb-3">
                                  <div align="center">URL de destination</div>
                                </th>
                                <th
                                  style="width: 200px"
                                  class="pb-3"
                                  v-if="selectedLinkType == 0 || selectedLinkType == 1"
                                >
                                  <div align="center">
                                    REL<span style="font-size: 12px">
                                      <br />
                                      (indique aux moteurs de recherche de suivre/ne pas
                                      suivre un lien)</span
                                    >
                                  </div>
                                </th>
                                <th style="width: 100px">
                                  <div align="center">
                                    Nombre maximum de lien(s) ajouté
                                  </div>
                                </th>
                                <th
                                  style="width: 20px"
                                  v-if="userInformation.admin_lvl == 2"
                                >
                                  <div align="center">
                                    <v-btn
                                      color="red"
                                      style="cursor: pointer"
                                      class="button_armo"
                                      icon
                                      density="compact"
                                      @click="selectedSiteToShow.link_connection = []"
                                    >
                                      <v-icon size="17"> mdi-trash-can </v-icon>
                                    </v-btn>
                                  </div>
                                </th>
                              </tr>
                            </thead>
                            <tbody style="background-color: white">
                              <tr
                                v-for="(
                                  elem2, idx2
                                ) in selectedSiteToShow.link_connection
                                  .filter((val) => val.value == selectedLinkType)
                                  .slice(
                                    (currentPage - 1) * elemMaxParPage,
                                    currentPage * elemMaxParPage
                                  )"
                                :key="idx2"
                                style=""
                              >
                                <td style="background-color: transparent">
                                  <v-col class="" align="center">
                                    <v-chip
                                      color="var(--C1)"
                                      style="border: solid 1px grey; font-weight: bold"
                                    >
                                      {{ (currentPage - 1) * elemMaxParPage + idx2 + 1 }}
                                    </v-chip>
                                  </v-col>
                                </td>
                                <td v-if="selectedLinkType != 2 && selectedLinkType != 3">
                                  <v-textarea
                                    v-model="elem2.key"
                                    hide-details
                                    placeholder="Ancre de lien"
                                    menu-icon=""
                                    auto-grow
                                    rows="1"
                                    bg-color="white"
                                    style="
                                      border-radius: 0px !important;
                                      overflow: auto;
                                      width: auto;
                                    "
                                  >
                                  </v-textarea>
                                </td>
                                <td>
                                  <v-textarea
                                    v-if="selectedLinkType != 0"
                                    v-model="elem2.url"
                                    density="compact"
                                    hide-details
                                    placeholder="https://mon-url..."
                                    menu-icon=""
                                    bg-color="white"
                                    auto-grow
                                    rows="1"
                                    style="
                                      border-radius: 0px !important;
                                      overflow: auto;
                                      width: 100%;
                                    "
                                  >
                                  </v-textarea>
                                  <div
                                    v-else-if="
                                      internLinkData[selectedSiteToShow.uuid] &&
                                      internLinkData[selectedSiteToShow.uuid]
                                        .finalUrlData &&
                                      selectedKeysToShow
                                    "
                                  >
                                    <v-autocomplete
                                      menu-icon=""
                                      density="compact"
                                      clearable
                                      no-data-text="Aucune page trouvée"
                                      placeholder="https://mon-url..."
                                      class="pa-0"
                                      v-model="elem2.url"
                                      bg-color="white"
                                      style="
                                        border-radius: 0px !important;
                                        width: 100%;
                                        overflow: auto;
                                      "
                                      :items="
                                        internLinkData[
                                          selectedSiteToShow.uuid
                                        ].finalUrlData
                                          .filter(
                                            (val2) =>
                                              !selectedSiteToShow.link_connection
                                                .map((val) => val.url)
                                                .includes(val2.value)
                                          )
                                          .filter((val) =>
                                            haveCommonElement(
                                              val.keys,
                                              selectedKeysToShow
                                            )
                                          )
                                      "
                                      hide-details
                                    >
                                      <template v-slot:chip="{ props, item }">
                                        <div
                                          v-bind="props"
                                          style="background-color: white; z-index: 1"
                                        >
                                          {{ item.value }}
                                        </div>
                                      </template>
                                      <template v-slot:item="{ props, item }">
                                        <v-list-item v-bind="props">
                                          {{ item.value.url }}
                                        </v-list-item>
                                      </template>
                                    </v-autocomplete>
                                  </div>
                                </td>
                                <td v-if="selectedLinkType == 0 || selectedLinkType == 1">
                                  <v-select
                                    :items="relListe"
                                    v-model="elem2.rel"
                                    item-value="value"
                                    item-title="label"
                                    hide-details
                                    bg-color="white"
                                    style="
                                      border-radius: 0px !important;
                                      width: 100%;
                                      overflow: auto;
                                    "
                                  >
                                  </v-select>
                                </td>
                                <td style="color: black; width: 150px" align="center">
                                  <v-select
                                    v-model="elem2.max"
                                    alig="center"
                                    :items="[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]"
                                    hide-details
                                  >
                                  </v-select>
                                </td>
                                <td
                                  style="background-color: white"
                                  v-if="userInformation.admin_lvl == 2"
                                >
                                  <div align="center" class="px-2">
                                    <v-btn
                                      color="red"
                                      style="cursor: pointer"
                                      class="button_armo"
                                      icon
                                      density="compact"
                                      @click="
                                        removeLink(selectedSiteToShow[subKey.key], elem2)
                                      "
                                    >
                                      <v-icon size="17"> mdi-trash-can </v-icon>
                                    </v-btn>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </v-card>
                        <v-col style="" align="center">
                          <v-btn
                            @click="currentPage -= 1"
                            :disabled="currentPage == 1"
                            class="button"
                            icon="mdi-minus"
                            density="compact"
                          ></v-btn>
                          Page : ({{ currentPage }} /
                          {{
                            Math.ceil(
                              selectedSiteToShow.link_connection.filter(
                                (val) => val.value == selectedLinkType
                              ).length / elemMaxParPage
                            )
                          }})
                          <v-btn
                            @click="currentPage += 1"
                            :disabled="
                              currentPage ==
                              Math.ceil(
                                selectedSiteToShow.link_connection.filter(
                                  (val) => val.value == selectedLinkType
                                ).length / elemMaxParPage
                              )
                            "
                            class="button"
                            icon="mdi-plus"
                            density="compact"
                          ></v-btn>
                        </v-col>
                      </v-col>
                      <Vue3EasyDataTable
                        :hide-footer="true"
                        table-class-name="customize-table-creation"
                        empty-message="Aucune redirection paramétrée"
                        @click-row="editLinkData"
                        header-text-direction="left"
                        body-text-direction="left"
                        :rows-per-page="rowsPerPage"
                        v-model:current-page="currentPage"
                        rows-of-page-separator-message="sur"
                        rows-per-page-message="Liens par page"
                        :table-height="windowheight - 420"
                        :items="paginatedItems"
                        :headers="headers"
                      >
                        <template #item-index="{ index }">
                          <v-chip
                            density="compact"
                            color="var(--C1)"
                            style="font-weight: bold"
                          >
                            {{ index }}
                          </v-chip>
                        </template>
                      </Vue3EasyDataTable>
                      <v-col class="pb-0 px-2">
                        <v-row justify="center" align="center">
                          <v-col>
                            <v-btn
                              variant="flat"
                              class="button"
                              :disabled="currentPage === 1"
                              @click="currentPage--"
                            >
                              ← Précédent
                            </v-btn>
                          </v-col>
                          <v-col align="center">
                            <div
                              class="button_armo pa-2"
                              style="color: var(--C1); font-weight: bold"
                            >
                              Affichage de {{ startItem }} à {{ endItem }} liens sur
                              {{ filteredItems.length }}
                            </div>
                          </v-col>
                          <v-col align="right">
                            <v-btn
                              variant="flat"
                              class="button"
                              :disabled="endItem >= filteredItems.length"
                              @click="currentPage++"
                            >
                              Suivant →
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-col>
                    </div>
                  </div>
                  <div v-else>
                    <v-col>
                      <v-progress-linear
                        color="var(--C1)"
                        height="4"
                        indeterminate
                        rounded
                      >
                      </v-progress-linear>
                    </v-col>
                  </div>
                </v-card>
                <v-card
                  v-else-if="subKey.key == 'photo_management'"
                  :class="subKey.class"
                  class="pa-3"
                  variant="flat"
                  style="border-radius: 10px"
                >
                  <v-col cols="12" class="pl-0" style="font-weight: bold">
                    Génération d'image
                  </v-col>
                  <v-divider class="mb-2"></v-divider>
                  <v-col class="px-0 pb-1">
                    <v-row>
                      <v-col
                        v-for="(elem2, idx2) in selectedSiteToShow[subKey.key].filter(
                          (val) => val.show == true
                        )"
                        :key="idx2"
                        align="center"
                        cols="12"
                        class="py-2"
                      >
                        <v-card
                          @click="setNewPhotoParam(selectedSiteToShow[subKey.key], elem2)"
                          variant="flat"
                          color="#EDEDED"
                          class="pa-5"
                          height="100%"
                          :style="
                            elem2.selected ? 'background:var(--BG);color:white;' : ''
                          "
                        >
                          <h4>
                            {{ elem2.label }}
                          </h4>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-card>
                <v-card
                  v-else
                  :class="subKey.class"
                  style="border-radius: 0px"
                  variant="flat"
                >
                  <v-text-field
                    :label="subKey.label"
                    v-model="selectedSiteToShow[subKey.key]"
                    hide-details
                  >
                  </v-text-field>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-card>
      </v-col>
      <!-- </v-expansion-panel-text>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col> -->
      <v-col align="center" class="pt-2">
        <v-btn variant="flat" class="button" @click="updateConfig()"> Enregistrer </v-btn>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import engine from "@/core/index";
import { v4 as uuidv4 } from "uuid";
import Vue3EasyDataTable from "vue3-easy-data-table";
import "vue3-easy-data-table/dist/style.css";

export default {
  components: {
    Vue3EasyDataTable,
  },
  data() {
    return {
      hideUpdateBtn: false,
      isLinkLoading: false,
      rowsPerPage: 25,
      currentPage: 1,
      selectedLinkData: {
        modal: false,
      },
      headers: [
        { text: "", value: "index", sortable: true },
        { text: "Ancre", value: "key", sortable: true, width: "300" },
        { text: "URL", value: "url", sortable: true },
        { text: "Rel", value: "rel", sortable: true, width: "150" },
        { text: "Max", value: "max", sortable: true, width: "100" },
      ],
      selectedPlatformToShow: "article_seo",
      platformToShow: ["article_seo"],
      selectedSiteToShow: undefined,
      selectedTheme: {},
      elemMaxParPage: 25,
      closeData: {},
      isAllSitePageLoading: false,
      panelOpened: 0,
      selectedPlatform: undefined,
      relListe: [
        {
          value: "dofollow",
          label: "dofollow",
          description:
            " Il indique à Google de faire le lien entre votre page et l'URL indiquée. Dès lors, il va être pris en compte dans l'algorithme de Google",
        },
        {
          value: "nofollow",
          label: "nofollow",
          description:
            "une balise utilisée pour les liens vers du contenu non approuvé. Cette balise est utilisée quand on ne peut pas appliquer Sponsored et UGC.",
        },
        {
          value: "ugc",
          label: "ugc",
          description:
            "une balise utilisée pour les liens vers du contenu généré par les utilisateurs : commentaires, avis, posts, etc",
        },
        {
          value: "sponsored",
          label: "sponsored",
          description:
            "une balise utilisée pour les liens vers du contenu sponsorisé et payant.",
        },
      ],
      selectedKeysToShow: [],
      selectedLinkType: 0,
      internLinkData: {},
      newTag: {},
      localUsernformation: {},
      localBlogListe: {},
      localGroupInformation: {},
    };
  },
  props: {
    windowheight: {},
    closeModal: { type: Function },
    // closeConfiguration: { type: Function },
    getLinksFormInformation: {},
    userInformation: {},
    groupInformation: { require: true },
    blogListe: {},
    sendNewConfig: { type: Function },
  },
  mounted() {
    let that = this;

    this.localGroupInformation = JSON.parse(JSON.stringify(this.groupInformation));
    this.localBlogListe = JSON.parse(JSON.stringify(this.blogListe));
    this.localUsernformation = JSON.parse(JSON.stringify(this.userInformation));

    this.selectedSiteToShow = this.localGroupInformation.web_site_data[
      this.selectedPlatformToShow
    ][0];

    if (this.selectedSiteToShow && this.selectedSiteToShow["words_liste"] == undefined)
      this.selectedSiteToShow["words_liste"] = "";

    console.log("selectedSiteToShow", this.selectedSiteToShow);
    console.log("keyToShow", this.keyToShow);

    if (this.localGroupInformation && this.localGroupInformation.web_site_data)
      this.selectedPlatform = Object.keys(this.localGroupInformation.web_site_data)[0];

    engine.get_site_url(this.groupInformation.id, function (data) {
      if (data.state == 200) {
        if (data.data[0].site_url && data.data[0].site_url.length > 0)
          that.internLinkData = JSON.parse(data.data[0].site_url);
        else that.internLinkData = {};
      }
    });
  },
  computed: {
    paginatedItems() {
      let start = (this.currentPage - 1) * this.rowsPerPage;
      return this.filteredItems.slice(start, start + this.rowsPerPage).map((item, i) => ({
        ...item,
        index: start + i + 1, // Index global (1 à N, pas 1 à 10 chaque page)
      }));
    },
    startItem() {
      return this.filteredItems.length === 0
        ? 0
        : (this.currentPage - 1) * this.rowsPerPage + 1;
    },
    endItem() {
      let end = this.currentPage * this.rowsPerPage;
      return end > this.filteredItems.length ? this.filteredItems.length : end;
    },
    filteredItems() {
      return this.selectedSiteToShow.link_connection.filter(
        (val) => val.value == this.selectedLinkType
      );
    },
    keyToShow() {
      let keys = [];

      // let keys = [
      //     //     {
      //     //     label: 'Nom de la société',
      //     //     key: 'label',
      //     //     class: 'mandatory',
      //     // }, {
      //     //     label: 'URL du site web',
      //     //     key: 'url',
      //     //     class: 'mandatory',
      //     // }, {
      //     //     label: 'Thème principal',
      //     //     key: 'type',
      //     //     class: 'optional',
      //     // },
      //     // {
      //     //     label: 'Clé API',
      //     //     key: 'compte_token',
      //     //     class: 'not-mandatory',
      //     // },
      //     {
      //         label: 'words_liste',
      //         key: 'words_liste',
      //         class: 'optional',
      //     }, {
      //         label: 'Liens',
      //         key: 'link_connection',
      //     }, {
      //         label: 'Photo',
      //         key: 'photo_management',
      //     }
      // ]

      keys.push({
        label: "words_liste",
        key: "words_liste",
        class: "optional",
      });
      if (this.linkData && this.linkData.length > 0)
        keys.push({
          label: "Liens",
          key: "link_connection",
        });
      keys.push({
        label: "Photo",
        key: "photo_management",
      });

      return keys;
    },
    linkData() {
      let links = [
        {
          label: "Liens internes",
          value: 0,
          key: "interne",
          keyToShow: "interne",
          cols: "",
        },
        {
          label: "Liens externes",
          value: 1,
          key: "externe",
          keyToShow: "externe",
          cols: "",
        },
        {
          icon: "mdi-block-helper",
          label: "",
          value: 2,
          keyToShow: " à bloqué",
          key: "blocked",
          cols: "auto",
          color: "red",
          size: 20,
          selectedSiteToShow:
            "Liste des liens (domaine) qui ne doivent surtout pas être utilisé dans la génération d'articles",
        },
        {
          icon: "mdi-check-circle",
          label: "",
          value: 3,
          keyToShow: " à utiliser",
          key: "use",
          cols: "auto",
          color: "green",
          size: 25,
          selectedSiteToShow:
            "Liste des liens (domaine) qui doivent être mis en avant et utiliser dans la génération d'articles",
        },
      ];

      let filteredLink = [];

      if (this.getLinksFormInformation.value)
        for (let i = 0; i < links.length; i++) {
          if (
            this.getLinksFormInformation.value.find((val) => val.value == links[i].value)
          )
            filteredLink.push(links[i]);
        }
      else return [];

      return filteredLink;
    },
    isMobile() {
      return this.$vuetify.display.mobile;
    },
  },
  methods: {
    updateProposition() {
      this.hideUpdateBtn = true;
      engine.update_proposition(this.groupInformation.id, function () {});
    },
    updateDataLink() {
      let index = this.selectedSiteToShow.link_connection.findIndex(
        (val) => val.uuid == this.selectedLinkData.data.uuid
      );

      this.selectedSiteToShow.link_connection[index] = this.selectedLinkData.data;

      this.selectedLinkData = {
        modal: false,
        data: undefined,
      };
    },
    editLinkData(data) {
      this.selectedLinkData = {
        modal: true,
        data,
      };
    },
    async filleUrl() {
      let that = this;
      for (const value of Object.values(this.localGroupInformation.web_site_data)) {
        for (let i = 0; i < value.length; i++) {
          if (this.selectedSiteToShow.uuid == value[i].uuid)
            if (this.internLinkData[value[i].uuid]) {
              let linkListe = this.internLinkData[value[i].uuid].finalUrlData;

              if (linkListe && linkListe.length > 0) {
                let usedUrl = value[i].link_connection.map((val) => val.url);
                linkListe = linkListe.filter((val) => !usedUrl.includes(val.value));
                if (linkListe && linkListe.length > 0) {
                  that.isAllSitePageLoading = true;
                  let total = linkListe.length;
                  let batchSize = 50;

                  this.isLinkLoading = true;
                  for (let a = 0; a < total; a += batchSize) {
                    let batch = linkListe.slice(a, a + batchSize);

                    await new Promise((resolve) => {
                      engine.get_ancre_for_url_link(batch, function (data) {
                        if (data.state === 200) {
                          value[i].link_connection = value[i].link_connection.concat(
                            data.data
                          );
                          that.sendNewConfig(that.localGroupInformation);
                        }
                        resolve();
                      });
                    });
                  }
                  that.isLinkLoading = false;
                  that.sendNewConfig(that.localGroupInformation);
                  that.isAllSitePageLoading = false;
                }
              }
            }
        }
      }
    },
    updateUrlListe() {
      for (const value of Object.values(this.localGroupInformation.web_site_data)) {
        for (let i = 0; i < value.length; i++) {
          if (value[i].uuid == this.selectedSiteToShow.uuid)
            this.getPageListeFromDomaine(value[i], value[i].uuid);
        }
      }
    },
    closeModalVerif() {
      let that = this;
      this.setCloseModal("Aucune modification ne sera sauvegardé", function () {
        that.closeModal();
      });
    },
    setCloseModal(label, callback) {
      this.closeData = {
        label,
        model: true,
        callback,
      };
    },
    setNewPhotoParam(elem, elem2) {
      for (let i = 0; i < elem.length; i++) {
        elem[i].selected = false;
      }
      elem2.selected = true;
    },
    removeLink() {
      let index = this.selectedSiteToShow.link_connection.findIndex(
        (val) => val.uuid == this.selectedLinkData.data.uuid
      );
      this.selectedSiteToShow.link_connection.splice(index, 1);

      this.selectedLinkData = {
        model: false,
        data: undefined,
      };
    },
    addLink() {
      let localLinkData = this.linkData[this.selectedLinkType];

      let newLinkData = {
        key: undefined,
        url: undefined,
        rel: "dofollow",
        uuid: uuidv4(),
        label: localLinkData.label,
        value: localLinkData.value,
        max: 1,
      };

      this.selectedSiteToShow.link_connection.unshift(newLinkData);
    },
    getPageListeFromDomaine(site, mainKey) {
      // let site = this.localBlogListe[val]
      let that = this;
      let finalUrlData = [];
      let finalKeyListe = [];
      let urlListeByType = {};

      if (site) {
        this.isAllSitePageLoading = true;
        this.isLinkLoading = true;
        engine.get_url_liste_from_domaine(site.web_site, function (data) {
          console.log("get_url_liste_from_domaine", data);

          if (data.state == 200) {
            let urlListe = data.data;
            for (let i = 0; i < urlListe.length; i++) {
              let url = urlListe[i];
              let keyUrl = urlListe[i].split(site.web_site)[1];
              if (url != null && url.includes("/")) {
                let keyListe = keyUrl.split("/").filter((val) => val.length > 0);
                if (keyListe.length >= 2) {
                  let long = keyListe.length;
                  let key = keyListe[long - 2];
                  let value = keyListe[long - 1];
                  if (urlListeByType[key] == undefined) urlListeByType[key] = [];
                  urlListeByType[key].push(value);
                }
                finalUrlData.push({
                  title: keyUrl,
                  value: url,
                  keys: keyListe,
                });
              }
            }
            that.internLinkData[mainKey] = {
              finalKeyListe,
              finalUrlData,
              urlListeByType,
            };
          } else {
            that.internLinkData[mainKey] = {
              finalKeyListe,
              finalUrlData,
              urlListeByType,
            };
          }
          that.isAllSitePageLoading = false;
          that.isLinkLoading = false;

          engine.set_site_url(
            that.groupInformation.id,
            JSON.stringify(that.internLinkData),
            function () {}
          );
        });
      } else that.internLinkData[mainKey] = { finalKeyListe, finalUrlData };
    },
    haveCommonElement(arr1, arr2) {
      if (arr2.length == 0) return true;
      if (arr1.includes(arr2)) return true;
      return false;
      // Créer un ensemble à partir du premier tableau
      // const set1 = new Set(arr1);

      // if (arr2.length == 0)
      //     return true
      // // Parcourir le deuxième tableau pour vérifier les éléments en commun
      // for (const elem of arr2) {
      //     if (set1.has(elem)) {
      //         return true;
      //     }
      // }

      // // Si aucun élément en commun n'est trouvé
      // return false;
    },
    addTag() {
      let tmpListe = this.selectedSiteToShow.words_liste.split(",");
      tmpListe.push(this.newTag[this.selectedSiteToShow.uuid]);
      tmpListe = tmpListe.join(",");
      this.selectedSiteToShow.words_liste = tmpListe;
      this.newTag[this.selectedSiteToShow.uuid] = undefined;
      // this.localGroupInformation.web_site_data[key][index].words_liste = tmpListe;
    },
    removeTag(index) {
      let tmpListe = this.selectedSiteToShow.words_liste.split(",");
      tmpListe.splice(index, 1);
      tmpListe = tmpListe.join(",");
      this.selectedSiteToShow.words_liste = tmpListe;
    },
    updateConfig() {
      let that = this;
      // let siteIndex = that.localGroupInformation.web_site_data[that.selectedPlatformToShow].find((val) => val.uuid == that.selectedSiteToShow.uuid)
      // that.localGroupInformation.web_site_data[that.selectedPlatformToShow][siteIndex] = that.selectedSiteToShow
      // console.log("siteIndex", siteIndex);

      this.setCloseModal("Valider mes modifications ?", function () {
        that.sendNewConfig(that.localGroupInformation);
        // that.closeModal();
        that.closeData.model = false;
      });
    },
    removeBusiness(key, index) {
      this.localGroupInformation.web_site_data[key].splice(index, 1);
    },
    addBusiness(key) {
      this.localGroupInformation.web_site_data[key].push({});
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style></style>
